import defaultTournamentLogo from "./../assets/images/defaultTournamentLogo.png";
import teamDefault from "./../assets/images/teamDefault.png";

export const generateRandomString = (length) => {
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getTeamProfilePic = (imageUrl) => {
  if (!imageUrl || imageUrl === "String") {
    return teamDefault;
  } else {
    return imageUrl;
  }
};

export const trimTrailingZeroes = (number) => {
  if (number) {
    let str = number.toString();
    if (str.indexOf(".") !== -1) {
      str = str.replace(/\.?0*$/, "");
    }

    return str;
  }
};

// export const getPlayerProfilePic = (imageUrl) => {
//   if (!imageUrl || imageUrl === "String") {
//     return require("../assets/images/defaultProfile.png");
//   } else {
//     return { uri: imageUrl };
//   }
// };

export const getTournamentProfilePic = (imageUrl) => {
  if (!imageUrl || imageUrl == "String") {
    return defaultTournamentLogo;
  } else {
    return imageUrl;
  }
};

export const getTournamentBanberPic = (imageUrl) => {
  if (!imageUrl || imageUrl == "String") {
    return require("../assets/images/defaultBannerImage.png");
  } else {
    return imageUrl;
  }
};

// export const trimTrailingZeroes = (number) => {
//   let str = number.toString();
//   if (str.indexOf(".") !== -1) {
//     str = str.replace(/\.?0*$/, "");
//   }

//   return str;
// };

// export const getStatDisplayValue = (value) => {
//   if (!value) return 0;
//   if (typeof value === "string") return value;
//   const parsedValue = trimTrailingZeroes(parseFloat(value).toFixed(2));

//   if (isNaN(parsedValue)) {
//     return 0;
//   } else {
//     return parsedValue;
//   }
// };

// export const getDisplayNameFromContact = (contact) => {
//   console.log("Contact => ", contact);

//   if (contact?.displayName) {
//     return contact?.displayName;
//   }

//   return `${contact?.givenName} ${contact?.familyName}`;
// };

export const maskStringAtStart = (
  str,
  lengthOfTheVisiblePart,
  padSymbolToBeAdded
) => {
  const visiblePart = str?.slice(lengthOfTheVisiblePart);
  const maskedString = visiblePart?.padStart(str?.length, padSymbolToBeAdded); // 1st - Total Resultant length, 2nd - Symbol to be added
  return maskedString;
};

export const maskStringAtEnd = (
  str,
  lengthOfTheVisiblePart,
  padSymbolToBeAdded
) => {
  const visiblePart = str?.slice(0, lengthOfTheVisiblePart);
  const maskedString = visiblePart?.padEnd(str?.length, padSymbolToBeAdded); // 1st - Total Resultant length, 2nd - Symbol to be added
  return maskedString;
};
